"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function isThenable(obj) {
  return obj && typeof obj.then === 'function';
}

var _default = isThenable;
exports.default = _default;
module.exports = exports.default;